<template>
  <v-app>
    <h1 class="headline font-weight-bold">のびポートフォリオ</h1>
    <!-- <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>Vuetify</span>
        <span class="font-weight-light">MATERIAL DESIGN</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        flat
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
      >
        <span class="mr-2">Latest Release</span>
      </v-btn>
    </v-toolbar> -->
    <v-content>
      <Author />
      <Works />
    </v-content>
  </v-app>
</template>

<script>
  import Author from './components/Author'
  import Works from './components/Works'

  export default {
    name: 'App',
    components: {
      Author,
      Works
    },
    mounted() {
      this.$ga.page('/');
    },
    data() {
      return {
        //
      }
    }
  }
</script>
<style lang="scss">
  @import "src/assets/scss/style.scss";
</style>
<style scoped lang="scss">
  h1{
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
</style>